import { render } from "./App.vue?vue&type=template&id=b21a60a2&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=b21a60a2&lang=css"

import exportComponent from "/Users/wenyu/vector/code/AntV/x6-demos-temp/vue/basic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__